import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ossCompanySelector = _resolveComponent("ossCompanySelector")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.dialog)
    ? (_openBlock(), _createBlock(_component_oss_dialog, {
        key: 0,
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialog) = $event)),
        "max-width": _ctx.$vuetify.display.mobile ? 'auto' : '900px',
        title: 'Gestionnaire des tâches',
        "previous-display": _ctx.windowStep !== 'default',
        onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.close())),
        onPrevious: _cache[16] || (_cache[16] = ($event: any) => (_ctx.previous())),
        onValid: _cache[17] || (_cache[17] = ($event: any) => (_ctx.windowStep === 'default' ? _ctx.valid() : _ctx.previous())),
        validTitle: _ctx.valueButton,
        validDisabled: !_ctx.isValid
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.windowStep,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.windowStep) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "default" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.taskValid,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.taskValid) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex justify-center align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex pa-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.task.title,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.task.title) = $event)),
                                label: "Titre",
                                outlined: "",
                                "hide-details": "",
                                rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                density: "compact"
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex pa-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                disabled: _ctx.readOnly,
                                cols: "6",
                                class: "d-flex pa-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ossCompanySelector, {
                                    modelValue: _ctx.task.client,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.task.client) = $event)),
                                    items: _ctx.allAvailableCompanies,
                                    selectClass: 'oss-dark',
                                    readonly: _ctx.readOnlyFieldDialog(),
                                    disabled: _ctx.readOnly,
                                    chipMaxLength: 9
                                  }, null, 8, ["modelValue", "items", "readonly", "disabled"])
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              (_ctx.isEditTaskReceive)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "6",
                                    class: "d-flex pa-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        label: "Créé par",
                                        outlined: "",
                                        readonly: true,
                                        "hide-details": "",
                                        "model-value": _ctx.formatUserTaskFrom(_ctx.task.owner),
                                        density: "compact"
                                      }, null, 8, ["model-value"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "12",
                            onClick: _ctx.openUsersChoice
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_combobox_filled, {
                                modelValue: _ctx.selectedUsers,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                                items: _ctx.selectedUsers,
                                "item-value": "id",
                                "item-title": (item) => _ctx.getUserDisplayName(item),
                                label: "Choix Collaborateur",
                                rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                dense: "",
                                readonly: "",
                                outlined: "",
                                chips: "",
                                multiple: "",
                                disabled: _ctx.readOnly
                              }, null, 8, ["modelValue", "items", "item-title", "rules", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                modelValue: _ctx.task.periodicity,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.task.periodicity) = $event)),
                                label: "Récurrence",
                                items: _ctx.periodicity,
                                readonly: _ctx.readOnlyFieldDialog(),
                                disabled: _ctx.readOnly,
                                "item-value": "value",
                                outlined: "",
                                density: "compact",
                                "item-title": (item) => item.name
                              }, null, 8, ["modelValue", "items", "readonly", "disabled", "item-title"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "3"
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.checkPeriodicity())
                                ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                    key: 0,
                                    modelValue: _ctx.task.dueDate,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.task.dueDate) = $event)),
                                    label: 'Échéance',
                                    textFieldReadOnly: false,
                                    rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                    disabled: _ctx.readOnly
                                  }, null, 8, ["modelValue", "rules", "disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "3"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.checkPeriodicity())
                                ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                    key: 0,
                                    modelValue: _ctx.task.start,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.task.start) = $event)),
                                    label: 'Début de récurrence',
                                    textFieldReadOnly: false,
                                    disabled: _ctx.readOnly,
                                    rules: [(v) => !!v || _ctx.$t('settings.itemRequired')]
                                  }, null, 8, ["modelValue", "disabled", "rules"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "3"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.checkPeriodicity())
                                ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                    key: 0,
                                    modelValue: _ctx.task.end,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.task.end) = $event)),
                                    notRequired: true,
                                    label: 'Fin de récurrence',
                                    textFieldReadOnly: false,
                                    disabled: _ctx.readOnly
                                  }, null, 8, ["modelValue", "disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                modelValue: _ctx.task.type,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.task.type) = $event)),
                                label: "Type de tâche",
                                items: _ctx.type,
                                "item-value": "value",
                                readonly: _ctx.readOnlyFieldDialog(),
                                disabled: _ctx.readOnly,
                                outlined: "",
                                rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                density: "compact",
                                "item-title": (item) => item.name
                              }, null, 8, ["modelValue", "items", "readonly", "disabled", "rules", "item-title"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                modelValue: _ctx.task.status,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.task.status) = $event)),
                                label: "Statut",
                                items: _ctx.typeStatus,
                                "item-value": "value",
                                outlined: "",
                                rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                density: "compact",
                                "item-title": (item) => item.name
                              }, null, 8, ["modelValue", "items", "rules", "item-title"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "d-flex pa-1",
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.task.description,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.task.description) = $event)),
                                label: "Description",
                                outlined: "",
                                clearable: "",
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "usersChoice" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "d-flex justify-center align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "pt-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_select_user, {
                            class: "px-1",
                            modelValue: _ctx.selectedUsers,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                            companyId: _ctx.companyId,
                            type: 'NATURAL_PERSON',
                            withEmail: true,
                            multiple: true,
                            step: _ctx.selectUserStep,
                            "onUpdate:step": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectUserStep) = $event))
                          }, null, 8, ["modelValue", "companyId", "step"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "previous-display", "validTitle", "validDisabled"]))
    : _createCommentVNode("", true)
}